/// <reference types="vinxi/types/client" />
import * as Sentry from '@sentry/tanstackstart-react';
import { StartClient } from '@tanstack/react-start';
import { hydrateRoot } from 'react-dom/client';

import { createRouter } from './router';

import { env } from '@/env';

const router = createRouter();

Sentry.init({
  dsn: env.VITE_SENTRY_DSN ?? undefined,

  sendDefaultPii: true,
});

hydrateRoot(document, <StartClient router={router} />);
